import {ConnectBasicEntity} from '../../framework/message/ConnectBasicEntity';

export class ProcessStepTasklet extends ConnectBasicEntity {
cnxCode: string;
fileExtension: string;
fileName: string;
keepResultInJobContext: boolean | null;
keepResultInStepContext: boolean | null;
linesToSkip: number | null;
processCode: string;
processStepCode: string;
removeFile: boolean | null;
storedProc: string;
taskletParams: string;
taskletSchema: string;
tsFileFormat: string;
visionCode: string;
witnessFileExtension: string;
}

